module.exports = __webpack_public_path__ + "static/bechar-2422c0e8774960976bbbf2df67856c8e.png";